import React, { Fragment } from 'react';
import ContactUsComponent from '../components/contact_v2/contact_us_component';
import PageHelmet from '../components/common/PageHelmet';

export default function ContactUsScreen() {
    return (
        <Fragment>
            <PageHelmet 
                title="Contact Us - Rubaai Digital Payment Solutions"
                description="Get in touch with Rubaai for all your digital payment needs. Contact our team for support, partnerships, or to learn more about our innovative payment solutions."
                keywords="contact Rubaai, customer support, payment solutions contact, fintech support, Rubaai contact information, customer service"
            />
            <ContactUsComponent />
        </Fragment>
    );
}
